import { INSIGHT_TYPE_VALUES, TInsightType } from './types';
import { SUPPORTED_INSIGHT_TAG_TYPES, TInsightTagType } from './insight-tag-types';

export const isInsightType = (v: any): v is TInsightType => INSIGHT_TYPE_VALUES.includes(v);

export const isSupportedInsightTagType = (v: any): v is TInsightTagType => SUPPORTED_INSIGHT_TAG_TYPES.includes(v);
